"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _MLKK6UGOcjs = require('../__chunks/MLKK6UGO.cjs');
require('../__chunks/MMSR5JSJ.cjs');


var _UCZW3OGHcjs = require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/composite/composite-provider.tsx
var _jsxruntime = require('react/jsx-runtime');
function CompositeProvider(props = {}) {
  const store = _MLKK6UGOcjs.useCompositeStore.call(void 0, props);
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _UCZW3OGHcjs.CompositeContextProvider, { value: store, children: props.children });
}


exports.CompositeProvider = CompositeProvider;
